import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import OrderSearch from '@afosto/app-components-react/OrderSearch';

const PurchaseOrderNumberFilter = ({
  onChange,
  operator,
  settings,
  suggestions,
  value,
  ...props
}) => {
  const [orders, setOrders] = useState([]);
  const valueRef = useRef(value);

  useEffect(() => {
    valueRef.current = value;
  });

  useEffect(() => {
    const initialValue = valueRef.current;

    const fetchOrders = async () => {
      try {
        const formattedOrders = (initialValue ?? []).reduce(
          (acc, result) => [...acc, { label: result, value: result }],
          [],
        );
        setOrders(formattedOrders);
      } catch (err) {
        setOrders([]);
      }
    };

    if (initialValue && initialValue?.length > 0) {
      fetchOrders();
    }
  }, []);

  const handleChange = (ev, selectedOrders) => {
    setOrders(selectedOrders);

    if (onChange && typeof onChange === 'function') {
      onChange(
        ev,
        selectedOrders.map(selectedOrder => selectedOrder?.label?.toLowerCase()),
      );
    }
  };

  return (
    <OrderSearch
      {...props}
      onChange={handleChange}
      value={orders}
      multiple
      enableCreate={false}
      validateOrder={false}
      filters={[
        {
          key: 'type',
          operator: 'in',
          values: ['purchase'],
        },
      ]}
    />
  );
};

PurchaseOrderNumberFilter.propTypes = {
  onChange: PropTypes.func,
  operator: PropTypes.string,
  settings: PropTypes.object,
  suggestions: PropTypes.array,
  value: PropTypes.array,
};

PurchaseOrderNumberFilter.defaultProps = {
  onChange: undefined,
  operator: undefined,
  settings: {},
  suggestions: [],
  value: [],
};

export default PurchaseOrderNumberFilter;
